import Vue from 'vue';
import Router from 'vue-router';
import Globe from '@/components/Globe';
import Local from '@/components/Local';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/global',
    },
    {
      path: '/global',
      name: 'global',
      component: Globe,
      meta: { bodyClass: 'global' },
      children: [
        {
          path: ':id',
          name: 'global.details',
        },
      ],
    },
    {
      path: '/local',
      name: 'local',
      component: Local,
      meta: { bodyClass: 'local' },
      children: [
        {
          path: ':parentId',
          name: 'local.overview',
          children: [
            {
              path: ':id',
              name: 'local.overview.details',
              children: [
                {
                  path: ':grandchild',
                  name: 'local.overview.grandchildDetails',
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js